import styles from './earnedPoints.module.css';

const earnedPointsStyle = {
    container: `flex bg-liveGameBackground gap-4 px-[20px] py-[25px] rounded-[10px]
               flex-row justify-between ${styles.container}`,
    userPointsSection: `!block     
                        md:!hidden
    `,
    bonusAndPolls: `flex flex-col gap-4
                    w-[46%] ${styles.bonusAndPolls}
    `,
    userPoint: `!hidden 
                md:!block
    `,
    pointsAndResults: `flex flex-col gap-0
                        w-[54%] ${styles.pointsAndResults}
    `,
}

export { earnedPointsStyle }